import { computed, makeObservable } from 'mobx';
import { Overlay } from 'src/domains/layouts/state/overlay/Overlay';
import { getWindowInnerWidth } from 'src_common/common/mobx-utils/Services/window';
import { NetworkConnectionState } from 'src/domains/layouts/state/networkConnectionState/NetworkConnectionState';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { PopupState } from 'src/domains/layouts/state/popupState/PopupState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { Common } from 'src/domains/common/Common';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

interface CallbacksType {
    getSearchStateIsShow: () => boolean;
}
export class IsStaticState {
    public constructor(
        private readonly common: Common,
        private readonly overlay: Overlay,
        private readonly popupState: PopupState,
        private readonly networkConnectionState: NetworkConnectionState,
        private readonly callbacks: CallbacksType
    ) {
        makeObservable(this);
    }

    @computed public get isStatic(): boolean {
        const starRouter = StarRouter.get(this.common);
        const config = ConfigComponents.get(this.common).config;
        const session = this.common.session;
        const accountView = starRouter.accountView;
        const innerWidth = getWindowInnerWidth() ?? 0;
        const isNewAccountDrawer = config.accountDrawerNew;

        if (this.popupState.popups?.type === 'gameModal') {
            return true;
        }

        if (accountView !== null) {
            if (session.isAuthorized) {
                if (accountView.account === 'login') {
                    return false;
                }
            }

            if (accountView.account === 'signup') {
                if (isNewAccountDrawer) {
                    return false;
                }

                return true;
            }

            if (accountView.account === 'finish-kyc') {
                return true;
            }

            if (innerWidth >= 1200 && this.overlay.isMenuOpen === true) {
                return false;
            }
        }

        if (this.overlay.shouldOverlayOpenWithIsStatic) {
            return true;
        }

        const appPlayersState = AppPlayersState.get(this.common);
        const specialEventsLandingPageShouldDisplay = appPlayersState.specialEvents.getLandingPageState(
            StarRouter.get(this.common).freeParams.promo ?? 'homepage'
        ).shouldDisplay;

        if (specialEventsLandingPageShouldDisplay) {
            return true;
        }

        if (innerWidth >= 1200 && this.callbacks.getSearchStateIsShow()) {
            return true;
        }

        if (this.networkConnectionState.showOfflineMessage) {
            return true;
        }

        return false;
    }
}
